import request from '@/utils/request'

// 获取资讯管理
export const GetInformAPI = (data) => request.get('/banners/information/', { params: data })

// 添加资讯
export const AddInformAPI = (data) => request.post('/banners/information/', data)

// 删除资讯
export const DelInformAPI = (id) => request.delete(`/banners/information/${id}/`)

// 获取资讯详情
export const EditInformAPI = (id) => request.get(`/banners/information/${id}/`)

// 更新资讯详情
export const PutInformAPI = (data) => request({
  method: 'put',
  url: `/banners/information/${data.get('id')}/`,
  data,
  headers: { 'Content-Type': 'multipart/form-data' }
})
